import CommandTriggerSimple from './Command/CommandTriggerSimple';

class MediaStreamManager {
    constructor() {
        this.remoteStream = null;
        this.mirrorStream = null;

        this.onRemoteStream = new CommandTriggerSimple(this);
        this.onMirrorStream = new CommandTriggerSimple(this);
        this.onRemoteTrack = null;
    }

    mirror() {
        return this.mirrorStream;
    }

    remote() {
        return this.remoteStream;
    }

    setRemoteStream(stream) {
        this.remoteStream = stream;
        this.onRemoteStream.trigger(this.remoteStream);
    }

    setMirror(stream) {
        this.mirrorStream = stream;
        this.onMirrorStream.trigger(this.mirrorStream);
    }
}

export default MediaStreamManager;
